<template>
  <div class="multi-form">
    <common-form :ref="'commonForm'" :layout="layout" v-for="(layout,index) in multiForms" :key="`${layout.key}_${index}`" :form-title="createdFormTitle(index)" :need-id="needId" :can-delete="multiForms.length>1?true:false" :can-edit="canEdit" :params="formParams&&formParams[index]?formParams[index]:{}" :field-path="fieldPath" @changed-fields="onFieldChange($event,index)" @current-changed-field="getCurrentChanged($event,index)" @update="update" @delete-detail="deleteDetail($event,index)"></common-form>
    <a-row style="margin-bottom:24px;" v-if="canEdit && canAdd">
      <a-col :xs="24" :sm="4"></a-col>
      <a-col :xs="24" :sm="10">
        <a-button class="blueBorderBtn" @click="add">+ 添加明细</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import UUID from 'uuidjs';
import CommonForm from './CommonForm.vue';
import _ from 'lodash';

export default {
  components: {
    CommonForm,
  },
  props: {
    layout: Object,
    params: Array,
    defaultParams: Object, // 新增明细时用到的默认参数值
    canEdit: Boolean,
    needId: Boolean,
    canAdd: {
      default: true,
      type: Boolean,
    },
    fieldPath: String,
  },
  data() {
    return {
      formConfigTemplate: _.isArray(this.layout.contents[0])
        ? _.cloneDeep(this.layout.contents)[0]
        : _.cloneDeep(this.layout.contents),
      multiForms: [],
      formParams: [],
      init: true,
    };
  },

  created() {},
  mounted() {
    this.formParams = [];
    this.params.forEach((item, index) => {
      this.$set(this.formParams, index, item);
    });
    if (this.init) {
      this.init = false;
      this.paramsTemplate = _.cloneDeep(this.params[0]);
      this.createFormlayout();
    }
  },

  computed: {},

  methods: {
    UUID: UUID.generate,
    onFieldChange(e, index) {
      this.$set(this.formParams, index, e);
      let formParams = {};
      formParams[this.layout.field] = this.formParams;
      this.$emit('changed-fields', formParams);
    },
    createdFormTitle(index) {
      if (this.layout.formTitle && this.canAdd) {
        return `${this.layout.formTitle}(${index + 1})`;
      } else if (!this.canAdd && this.layout.formTitle) {
        return `${this.layout.formTitle}`;
      } else {
        return undefined;
      }
    },
    createFormlayout() {
      this.multiForms = [];
      const formConfig = {
        type: 'commonForm',
        contents: _.isArray(this.layout.contents[0])
          ? _.cloneDeep(this.layout.contents)[0]
          : _.cloneDeep(this.layout.contents),
      };
      if (_.isArray(this.layout.contents[0])) {
        // 用来兼容详情页各个明细的表单不一样的（取后端返的数据）例如报销单详情的明细
        this.layout.contents.forEach((item, index) => {
          const form = {
            type: 'commonForm',
            key: this.UUID(),
            contents: _.cloneDeep(item),
          };
          this.$set(this.multiForms, index, form);
        });
      } else {
        if (this.formParams.length > 0) {
          this.formParams.forEach((item, index) => {
            formConfig.key = this.UUID();
            this.$set(this.multiForms, index, _.cloneDeep(formConfig));
          });
        } else {
          formConfig.key = this.UUID();
          this.$set(this.multiForms, 0, _.cloneDeep(formConfig));
        }
      }
    },
    validateFields() {
      let validateResult = true;
      this.$refs.commonForm.forEach(item => {
        if (!item.validateFields()) {
          validateResult = false;
        }
      });
      return validateResult;
    },
    add() {
      // 以第一条明细布局为模板
      this.formConfigTemplate = _.isArray(this.layout.contents[0])
        ? _.cloneDeep(this.layout.contents)[0]
        : _.cloneDeep(this.layout.contents);
      const formConfig = {
        type: 'commonForm',
        key: this.UUID(),
        contents: _.cloneDeep(this.formConfigTemplate),
      };
      this.multiForms.push(formConfig);
      const defaultParams = this.defaultParams[this.layout.field]
        ? this.defaultParams[this.layout.field][0]
        : {};
      this.formParams.push(defaultParams);
    },
    update(e) {
      this.$emit('update', e);
    },
    deleteDetail(e, index) {
      this.formParams.splice(index, 1);
      this.multiForms.splice(index, 1);
      let formParams = {};
      formParams[this.layout.field] = this.formParams;
      this.$emit('changed-fields', formParams);
    },
    eventRelay(e) {
      const self_event = e[0];
      let behind_event = _.cloneDeep(e);
      behind_event.shift();
      if (self_event.selfDo === 'emit') {
        this.$emit('event-relay', behind_event);
      } else if (self_event.selfDo === 'broadcast') {
        let childrenVm = this.$refs.commonForm;
        childrenVm.forEach(item => {
          item.eventRelay(behind_event);
        });
      }
    },
    getCurrentChanged(e, index) {
      e[Object.keys(e)[0]].ofMultiFormIndex = index;
      this.$emit('current-changed-field', e);
    },
    refreshFormConfig(index, contents, currentDefaultParams) {
      let oldCurrentIndexParams = _.cloneDeep(this.formParams[index]);
      let currentDefaultParamsBackup = _.cloneDeep(currentDefaultParams)[0];
      contents.forEach(config => {
        // 需求上参数保留之前填写的，由于报销明细里的预算科目受报销类别联动更新，所以不能保留原预算科目值
        if (!config.disabled && oldCurrentIndexParams[config.field]) {
          currentDefaultParamsBackup[config.field] =
            oldCurrentIndexParams[config.field];
        }
      });
      setTimeout(() => {
        this.$set(this.formParams, index, currentDefaultParamsBackup);
        const newFormConfig = {
          type: 'commonForm',
          key: this.UUID(),
          contents: _.cloneDeep(contents),
        };
        this.$set(this.multiForms, index, newFormConfig);
      }, 100);
    },
    refreshAll(index, contents) {
      this.multiForms[index].contents = [];
      setTimeout(() => {
        const newFormConfig = {
          type: 'commonForm',
          key: this.UUID(),
          contents: _.cloneDeep(contents),
        };
        this.$set(this.multiForms, index, newFormConfig);
      }, 100);
    },
    updateChildConfig(configField, value) {
      this.$refs.commonForm.forEach(item => {
        item.updateFieldValue(configField, value);
      });
    },
  },
  watch: {
    params: {
      handler: function(val) {},
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less">
</style>
